export default "__VITE_ASSET__Bz5uPX1S__"